/**
 * Thrown when an environment key names no known environment -- a configuration mistake, not
 * a transient failure.
 *
 * Named so callers can tell it from a failed request. Resolution can happen inside a mutation
 * (see useEntityCreate's per-call target), where a bare Error carries no HTTP status and bulk
 * retry treats "no status" as a network blip -- turning one misconfiguration into N retries.
 *
 * Lives here rather than beside the hook that throws it, so batch-async-operations can
 * classify the failure without importing a hook module.
 */
export class UnknownEnvironmentError extends Error {
  constructor(environment: string) {
    super(`Unknown environment: ${environment}`);
    this.name = 'UnknownEnvironmentError';
  }
}
